
import * as React from 'react';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import UserPointsBadge from './UserPointsBadge';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import HomeIcon from '@mui/icons-material/Home';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';

import { useAppState } from '../../reduxish/appState';


export default function NavbarDesktop() {
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

    const { state } = useAppState();
    const { signOut, authUser, isAuthenticated } = state.auth!;
    const monthlyPoints = state.userPoints?.monthly ?? 0;

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <AppBar position="sticky" sx={{ top: 0 }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    {/* <Typography sx={{ display: { xs: 'none', md: 'flex' }, mr: 2 }} component={RouterLink} to="/" >
                        <HomeIcon />
                    </Typography> */}
                    <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                        <Typography sx={{ display: { xs: 'none', md: 'flex' }, mr: 2 }} >
                            <HomeIcon />
                        </Typography>
                    </Link>
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {/* <MenuItem component={RouterLink} to="/about">
                                About
                            </MenuItem> */}
                            <Link to="/about" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <MenuItem>
                                    About
                                </MenuItem>
                            </Link>
                        </Menu>
                    </Box>
                    <Typography sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, mr: 1 }} >
                        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <HomeIcon />
                        </Link>
                    </Typography>
                    {/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />
                    <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        href="/"
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        LOGO
                    </Typography> */}
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {/* <Button
                            key='about-link'
                            component={RouterLink} to="/about"
                            sx={{ my: 2, color: 'white', display: 'block' }}
                        >
                            About
                        </Button> */}
                        <Link to="/about" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <Button key='about-link' sx={{ my: 2, color: 'primary.contrastText', display: 'block' }}>
                                About
                            </Button>
                        </Link>
                    </Box>
                    <Box sx={{ flexGrow: 0 }}>
                        {
                            (isAuthenticated && authUser)
                                ?
                                <>
                                    <Tooltip title="Open settings">
                                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                            <UserPointsBadge points={monthlyPoints}>
                                                <Avatar alt={authUser.displayName} src={authUser.photoURL} sx={{ bgcolor: 'primary.dark', color: 'secondary.contrastText' }} />
                                            </UserPointsBadge>
                                        </IconButton>
                                    </Tooltip>
                                    <Menu
                                        sx={{ mt: '45px' }}
                                        id="menu-appbar"
                                        anchorEl={anchorElUser}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElUser)}
                                        onClose={handleCloseUserMenu}
                                    >
                                        {/* <MenuItem key='user-profile' component={RouterLink} to="/profile">
                                            <Typography textAlign="center">Profile</Typography>
                                        </MenuItem> */}
                                        <Link to="/profile" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <MenuItem key='user-profile'>
                                                <Typography sx={{ textAlign: 'center' }}>Profile</Typography>
                                            </MenuItem>
                                        </Link>
                                        <MenuItem key='user-logout' onClick={signOut} >
                                            <Typography sx={{ textAlign: 'center' }}>Sign Out</Typography>
                                        </MenuItem>
                                    </Menu>
                                </>
                                :
                                <Box sx={{ flexGrow: 1, display: 'flex' }}>
                                    <Link to="/signin" style={{ textDecoration: 'none', color: 'inherit' }}>
                                        <Button
                                            key='about-link'
                                            sx={{ my: 2, color: 'primary.contrastText', display: 'block' }}
                                        >
                                            Sign In
                                        </Button>
                                    </Link>
                                </Box>
                        }
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}